import { collection, addDoc, getDocs, query, orderBy, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';

const vegetablesService = {
  async addVegetable(name) {
    try {
      const docRef = await addDoc(collection(db, 'vegetables'), {
        name,
        createdAt: new Date().toISOString(),
      });
      return {
        id: docRef.id,
        name,
        createdAt: new Date().toISOString()
      };
    } catch (error) {
      console.error('Error adding vegetable:', error);
      throw error;
    }
  },

  async getVegetables() {
    try {
      const q = query(collection(db, 'vegetables'), orderBy('name'));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting vegetables:', error);
      throw error;
    }
  },

  async updateVegetable(id, data) {
    try {
      const docRef = doc(db, 'vegetables', id);
      await updateDoc(docRef, data);
      return { id, ...data };
    } catch (error) {
      console.error('Error updating vegetable:', error);
      throw error;
    }
  },

  async deleteVegetable(id) {
    try {
      const docRef = doc(db, 'vegetables', id);
      await deleteDoc(docRef);
    } catch (error) {
      console.error('Error deleting vegetable:', error);
      throw error;
    }
  }
};

export default vegetablesService;